import { useCallback, useEffect, useState } from 'react';

export const useButtonScroll = (
    scrollBarRef: React.RefObject<HTMLDivElement>,
) => {
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [rightScrollDisabled, setDisableRightScroll] = useState(false);

    const handleScroll = useCallback(() => {
        if (!scrollBarRef?.current) return;
        setShowLeftArrow(() => scrollBarRef.current?.scrollLeft !== 0);
        setDisableRightScroll(
            () =>
                scrollBarRef.current?.scrollWidth ===
                (scrollBarRef.current?.scrollLeft ?? 0) +
                    (scrollBarRef.current?.clientWidth ?? 0),
        );
    }, [scrollBarRef]);

    useEffect(() => {
        if (!scrollBarRef?.current) return;
        const scrollBar = scrollBarRef.current;
        scrollBar?.addEventListener('scroll', handleScroll);

        return () => {
            scrollBar?.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll, scrollBarRef]);

    return { showLeftArrow, rightScrollDisabled };
};
